module.exports = __webpack_public_path__ + "static/media/33.5a084223.png";